import { FC, memo } from 'react';
import { Star } from 'lucide-react';

export type ButtonStarChangeType = 'click' | 'hover' | 'leave';

interface ButtonStarProps {
  value: number;
  isActive: boolean;
  disabled?: boolean;
  onChange: (value: number, type: ButtonStarChangeType) => void;
}

export const ButtonStar: FC<ButtonStarProps> = memo(({ value, isActive, disabled, onChange }) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(value, 'click');
    }
  };

  const handleMouseEnter = () => {
    if (!disabled) {
      onChange(value, 'hover');
    }
  };

  const handleMouseLeave = () => {
    if (!disabled) {
      onChange(value, 'leave');
    }
  };

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="border-0 bg-transparent p-0 cursor-pointer disabled:cursor-not-allowed"
      aria-label={`Rate ${value} stars`}
    >
      <Star
        className={`h-4 w-4 stroke-current transition-all ${
          isActive ? 'text-(--primary-O1000) fill-current' : 'text-(--neutral-white-NW700)'
        }`}
      />
    </button>
  );
});
